module.exports = __webpack_public_path__ + "static/media/brand-4.f47a228a.png";